import { LangDict } from "@/types/LangDict";
import { Path } from "react-hook-form";

type ResKey<ObjType extends Record<string, any>, ParentKey extends string> = ParentKey extends ""
  ? Path<ObjType>
  : `${ParentKey}.${Path<ObjType>}`;

type ResType<ObjType extends Record<string, any>, ParentKey extends string> = Record<
  ResKey<ObjType, ParentKey>,
  string
>;

function flattenObj<
  ObjType extends Record<string, any>,
  ParentKey extends string,
  ResultType extends ResType<ObjType, ParentKey> = ResType<ObjType, ParentKey>,
>(obj: ObjType, parentKey: ParentKey, result: Record<string, any> = {}) {
  for (const key in obj) {
    const newKey = (parentKey ? `${parentKey}.${key}` : key) as ResKey<ObjType, ParentKey>;

    if (typeof obj[key] === "object" && obj[key] !== null) {
      flattenObj(obj[key], newKey, result);
    } else {
      result[newKey] = obj[key];
    }
  }

  return result as ResultType;
}

export function flattenDictionary(dict: LangDict) {
  return flattenObj(dict, "");
}

export default flattenDictionary;
